import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { dispatchEvent } from 'fg-frontend/src/lib/dom';

export default class PersonalPickupSelect extends WebComponent {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  didMount() {
    const pickupElement = document.querySelector('#personalPickupLocationCode');
    this.element.value = pickupElement.value;
    if (this.element.value === '') {
      pickupElement.value = this.element.querySelector('option:first-child').value;
      dispatchEvent(pickupElement, 'change');
    }
    if (this.element.length > 1) {
      this.element.addEventListener('change', this.handleChange);
    }
  }

  willUnMount() {
    this.element.removeEventListener('change', this.handleChange);
  }

  handleChange(event) {
    const saveElement = document.querySelector('#personalPickupLocationCode');
    saveElement.value = event.target.value;
    dispatchEvent(saveElement, 'change');
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/PersonalPickupSelect.js